import { render, staticRenderFns } from "./ConfigCategoryEvents.vue?vue&type=template&id=601a7a68&"
import script from "./ConfigCategoryEvents.vue?vue&type=script&lang=js&"
export * from "./ConfigCategoryEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports